export class AdminDataReporting {
  applicantFirstName: string;

  applicantMiddleName: string;

  applicantLastName: string;

  applicantDateOfBirth: string;

  applicationId: string;

  isSubmitted: boolean;

  submittedOn: string;

  applicantEmail: string;

  accountVerified: string;

  createdAt: string;

  maritalStatus: string;
}
